/** Positive server IDs and negative IDs allocated by the local operation queue. */
export function parseEntityId(value: string | null | undefined): number | null {
  if (!value || !/^-?\d+$/.test(value)) return null;
  const id = Number(value);
  return Number.isSafeInteger(id) && id !== 0 ? id : null;
}
